import { randomValue } from '@/mixins/random';

export default {
	state: {
		unfedCount: 0,
		selected: [],
		selectionKey: "",
		breeds: {
			old: [],
			new: [],
		},
		dead: 0,
		queued: {},
	},
	actions: {
		selectCats(context, payload) {
			context.commit("setBoardColor", { color: payload.background_color });
			context.commit("setSelectionKey", { key: payload.key });

			payload.breedIndexes.forEach((breedIndex) => {
				const breed = context.rootState.config.breeds[breedIndex];
				context.commit("selectCat", { breed });
			});

			context.commit("incrementFood", { amount: context.rootGetters.initialBreedScoopCount });
			context.dispatch("initializeCatQueue").then(() => {
				context.dispatch("initializeCycleBalance", {
					breeds: context.state.breeds.new,
				});
			});
		},
		initializeCatQueue(context) {
			context.dispatch("queueBreed");

			return new Promise((resolve) => {
				for (let i = 0; i < context.rootState.config.general.initial_cat_count; i += 1) {
					context.dispatch("activateCatFromQueue");
				}
				resolve();
			});
		},
		prepareCatQueue(context) {
			context.commit("resetNewCats");
			let scoopDebt = context.getters.scoopDebt;

			while (scoopDebt >= context.state.queued.food_required) {
				scoopDebt -= context.state.queued.food_required;

				if (scoopDebt >= 0) {
					context.dispatch("activateCatFromQueue");
				}
			}

			context.commit("setUnfedCatCount", { amount: context.getters.activeCatCount });
		},
		activateCatFromQueue(context) {
			context.commit("addNewCat");
			context.dispatch("queueBreed");
		},
		queueBreed(context) {
			context.commit("setQueue", {
				breed: context.getters.randomCatConfig(),
			});
		},
	},
	mutations: {
		resetNewCats(state) {
			state.breeds.old = state.breeds.old.concat(state.breeds.new);
			state.breeds.new = [];
		},
		setQueue(state, payload) {
			state.queued = payload.breed;
		},
		addNewCat(state) {
			state.breeds.new.push(state.queued.name);
		},
		incrementDeadCats(state) {
			state.dead += 1;
		},
		setUnfedCatCount(state, payload) {
			state.unfedCount = payload.amount;
		},
		decrementUnfedCatCount(state) {
			state.unfedCount -= 1;
		},
		selectCat(state, payload) {
			state.selected.push(payload.breed);
		},
		setSelectionKey(state, payload) {
			state.selectionKey = payload.key;
		},
		setFoodDebt(state, payload) {
			state.foodDebt = payload.amount;
		},
	},
	getters: {
		hasSelectedCats(state) {
			return state.selected.length;
		},
		selectedCatBreed(state) {
			return () => state.selected[0];
		},
		breedByName(state, getters, rootState) {
			return name => rootState.config.breeds.find(breed => breed.name === name);
		},
		randomCatConfig(state) {
			return () => randomValue(state.selected);
		},
		randomBreedName(state, getters) {
			return () => getters.randomCatConfig().name;
		},
		activeCatCount(state) {
			return state.breeds.old.length + state.breeds.new.length;
		},
		scoopDebt(state, getters, rootState, rootGetters) {
			const breeds = state.breeds.old.concat(state.breeds.new);
			let scoops = 0;

			breeds.forEach((breedName) => {
				scoops += rootGetters.breedByName(breedName).food_required;
			});

			return rootState.cycle.balance - scoops;
		},
		initialBreedScoopCount(state, getters, rootState, rootGetters) {
			let amount = 0;

			if (rootState.cats.selectionKey === "mixed_litter") {
				amount = rootState.config.mixed_litter.initial_scoop_count;
			} else if (rootGetters.hasSelectedCats) {
				amount = getters.selectedCatBreed().initial_scoop_count;
			}

			return amount;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/cats.js